import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'alert-presentata',
    template: `
  <div class="bg-primary  border-s-4 border-primary  rounded p-4 mt-5">
  <p class="mb-10 text-primary">
  <span class="font-semibold">{{model.titolo}}</span>
  </p>

  <div class="flex items-center">
  <div class="inline-flex">


  <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_outline:check-circle'"></mat-icon>
  <p class="ml-2 text-primary">
  <span class="font-semibold">Procedura COMPLETATA</span>
  </p>

  </div>

  <span class="sr-only">Info</span>
  <h3 class="font-medium ml-3 text-primary">La tua richiesta è stata inoltrata correttamente.</h3>
</div>
<hr class="border-2">
<div class="h-5 text-black">
<img src="assets/icons/pagopa.svg" alt="paga con pagoPA" class="h-10 text-gray-50">
</div>
<hr class="border-2">

<div class="mb-0.5 text-primary">
L'istanza è in corso di protocollazione. A breve riceverai un' email con il numero di protocollo.
</div>

</div>
  `,
    standalone: true,
    imports: [FormlyModule, MatIconModule]
})
export class AlertPresentataComponent extends FieldWrapper {
}
